import { prop } from "ramda";
import { createSelector } from "reselect";
import { STATE_IDENTIFIER } from "./constants";

const { NUM_TASK, NUM_APPROVAL, NOTIFY_MSG } = STATE_IDENTIFIER;

const welcomeState = (state: any) => state.welcomeState;

export const numTaskSelector: any = createSelector(
  welcomeState,
  prop(NUM_TASK)
);

export const numApprovalSelector: any = createSelector(
  welcomeState,
  prop(NUM_APPROVAL)
);

export const notificationSelector: any = createSelector(
  welcomeState,
  prop(NOTIFY_MSG)
);
